import { array, object, string } from 'yup'
import * as R from 'ramda'
import { t } from 'ttag'

import {
  INTERVIEW_MOUDLE_FIELD,
  INTERVIEW_TEMPLATE_FIELD,
  MODULES_FIELD,
} from './model'

export const getSchema = () =>
  object().shape({
    [MODULES_FIELD]: array()
      .of(
        object()
          .shape({ name: string() })
          .required(),
      )
      .test(
        'at-least-one-module',
        t`At least one module must be selected.`,
        modules => R.any(module => module[module.name] === R.T(), modules),
      ),
    [INTERVIEW_TEMPLATE_FIELD]: object()
      .shape(
        { label: string(), value: string() },
        `${MODULES_FIELD}[2].${INTERVIEW_MOUDLE_FIELD}`,
      )
      .when(`${MODULES_FIELD}[2].${INTERVIEW_MOUDLE_FIELD}`, {
        is: true,
        then: schema => schema.required(t`This field cannot be empty.`),
        otherwise: schema => schema.notRequired(),
      }),
  })
